

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
/* FALLBACK IMAGES */
import veg from "../../images/product_img_1.jpg";
import rice from "../../images/product_img_2.jpg";
import meat from "../../images/product_img_3.jpg";
import spices from "../../images/product_img_4.jpg";
import dairy from "../../images/product_img_5.jpg";
import bulk from "../../images/product_img_6.jpg";

const API_BASE_URL = "https://api.mahal.qa/api";

const COLORS = [
  "#2ecc71", "#f1c40f", "#e74c3c",
  "#e67e22", "#3498db", "#9b59b6"
];

const FALLBACK_IMAGES = [veg, rice, meat, spices, dairy, bulk];

const MahalIntentSection = () => {
  const [intents, setIntents] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
const getCategoryTitle = (item) => {
  return item.title;
};

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const lang = i18n.language?.startsWith("ar") ? "ar" : "en";
        const res = await axios.get(`${API_BASE_URL}/category?lang=${lang}`);

        if (!res.data || res.data.length === 0) return;

        const dynamic = res.data.map((cat, index) => {
          let imgUrl;

          if (cat.image && cat.image !== "null") {
            imgUrl = cat.image.startsWith("http")
              ? cat.image
              : `https://api.mahal.qa${cat.image}`;
          } else {
            imgUrl = FALLBACK_IMAGES[index % FALLBACK_IMAGES.length];
          }

          return {
            title: cat.display_name || cat.name,
            category: cat.name,
            color: COLORS[index % COLORS.length],
            img: imgUrl
          };
        });

        setIntents(dynamic);

      } catch (err) {
        console.error("API ERROR:", err);
      }
    };

    fetchCategories();
  }, [i18n.language]);
const displayIntents = isArabic ? [...intents].reverse() : intents;

  return (
    <div className="container mt-5" dir={isArabic ? "rtl" : "ltr"}>

      {/* HEADING */}
      <div className="text-center mb-5">
        <h4 className="premium_badge text-white">
          {t("what_are_you_ordering_today")}
        </h4>
        <h2 className="premium_title">
          {t("choose_kitchen_needs")}
        </h2>
      </div>

      {/* MARQUEE */}
      <div className="mm-category-wrapper">
        
        <div
          className="mm-category-track"
        >
          {[...displayIntents, ...displayIntents].map((item, index) => (
            <div
              key={index}
              onClick={() =>
                navigate(
                  `/categorieList?category=${encodeURIComponent(item.category)}`
                )
              }
              id="categoty"
              style={{
                textAlign: "center",
                cursor: "pointer",
                minWidth: "120px"
              }}
            >
              {/* CIRCLE */}
              <div
              id="categoty1"
              
              >
                <img
                  src={item.img}
                  alt={getCategoryTitle(item)}
                  onError={(e) => (e.target.src = veg)}
                />
              </div>

              <p style={{ marginTop: "10px", fontWeight: "500" }}>
                {getCategoryTitle(item)}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ANIMATION */}
<style>
  {`
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
  `}
</style>

    </div>
  );
};

export default MahalIntentSection;